module.exports = __webpack_public_path__ + "img/img-1.d4abb833.svg";